import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface EmailCompositionState {
  emailSubject: string;
  emailContent: string;
  selectedTemplate: string | null;
  isSending: boolean;
  sendError: string | null;
  lastSendResult: any | null;
}

const initialState: EmailCompositionState = {
  emailSubject: "",
  emailContent: "",
  selectedTemplate: null,
  isSending: false,
  sendError: null,
  lastSendResult: null,
};

const emailCompositionSlice = createSlice({
  name: "emailComposition",
  initialState,
  reducers: {
    setEmailSubject: (state, action: PayloadAction<string>) => {
      state.emailSubject = action.payload;
    },
    setEmailContent: (state, action: PayloadAction<string>) => {
      state.emailContent = action.payload;
    },
    setSelectedTemplate: (state, action: PayloadAction<string | null>) => {
      state.selectedTemplate = action.payload;
    },
    setSending: (state, action: PayloadAction<boolean>) => {
      state.isSending = action.payload;
    },
    setSendError: (state, action: PayloadAction<string | null>) => {
      state.sendError = action.payload;
    },
    setLastSendResult: (state, action: PayloadAction<any | null>) => {
      state.lastSendResult = action.payload;
    },
    resetEmailForm: (state) => {
      state.emailSubject = "";
      state.emailContent = "";
      state.selectedTemplate = null;
      state.sendError = null;
      state.lastSendResult = null;
    },
    loadTemplateContent: (
      state,
      action: PayloadAction<{ subject: string; content: string }>
    ) => {
      state.emailSubject = action.payload.subject;
      state.emailContent = action.payload.content;
    },
  },
});

export const {
  setEmailSubject,
  setEmailContent,
  setSelectedTemplate,
  setSending,
  setSendError,
  setLastSendResult,
  resetEmailForm,
  loadTemplateContent,
} = emailCompositionSlice.actions;

export default emailCompositionSlice.reducer;
